import React, { useState, useEffect } from "react";
import { Drawer } from "antd";
import RackAcomodo from "./RackAcomodo";

//Drawer que se abre con doble clic en un rack (LienzoMapaWms.js). Muestra el acomodo del rack (mapa +
//lista + edición). Para racks grandes (>10x10) RackAcomodo sugiere abrirlo en pantalla completa vía
//onConfigurarEnPagina (lo provee MapaWms, que tiene el history para navegar).
const RackDetalleDrawer = ({
  visible,
  onClose,
  rackId,
  empresaId,
  proyectoId,
  headersToken,
  permisoAgregarUbicacion,
  permisoDeshabilitarUbicacion,
  onConfigurarEnPagina,
}) => {
  const [rack, setRack] = useState(null);

  // Limpia el título al cerrar para no mostrar el del rack anterior al reabrir.
  useEffect(() => {
    if (!visible) setRack(null);
  }, [visible]);

  return (
    <Drawer
      title={rack ? `Rack ${rack.codigo}${rack.nombre ? " - " + rack.nombre : ""}` : "Detalle del rack"}
      visible={visible}
      onClose={onClose}
      width={960}
    >
      <RackAcomodo
        rackId={rackId}
        empresaId={empresaId}
        proyectoId={proyectoId}
        headersToken={headersToken}
        permisoAgregarUbicacion={permisoAgregarUbicacion}
        permisoDeshabilitarUbicacion={permisoDeshabilitarUbicacion}
        activo={visible}
        enPagina={false}
        onRackLoaded={setRack}
        onConfigurarEnPagina={(rid) => {
          onClose();
          if (onConfigurarEnPagina) onConfigurarEnPagina(rid);
        }}
      />
    </Drawer>
  );
};

export default RackDetalleDrawer;
